import React from 'react';
import InternalMenu from '../../components/shared/InternalMenu';

const SupportPageView = ({ 
  activeCategory, 
  setActiveCategory,
  searchQuery, 
  filteredFaqs,
  handleSearchChange,
  sidebarItems
}) => {
  return (
    <div className="min-h-screen bg-black">
      <div className="bg-gradient-to-r from-teal-800 to-cyan-900 w-full">
        <div className="max-w-6xl mx-auto text-center py-16 px-4">
          <h1 className="text-4xl font-bold text-white mb-2">Q&A</h1>
          <p className="text-xl text-teal-100 mb-8">How can we help you today?</p>
          <div className="max-w-md mx-auto">
            <input
              type="text"
              placeholder="Search for answers..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full px-4 py-3 rounded-lg bg-gray-900 border border-gray-700 text-white placeholder-gray-400 focus:ring-2 focus:ring-teal-500 focus:border-transparent focus:outline-none"
            />
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <InternalMenu 
            items={sidebarItems}
            activeItemId={activeCategory}
            onItemClick={setActiveCategory}
            className="md:col-span-1"
          />

          <main className="md:col-span-3">
            <div className="space-y-8">
              {Object.entries(filteredFaqs).map(([category, questions]) => (
                (activeCategory === category || searchQuery) && (
                  <div key={category} className="faq-category">
                    <div className="space-y-6">
                      {questions.map((faq, index) => (
                        <div key={index} className="bg-gray-900 rounded-lg p-6 border border-gray-800">
                          <h3 className="text-lg font-semibold mb-3 text-white">{faq.question}</h3>
                          <p className="text-gray-300">{faq.answer}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ))}
            </div>
          </main>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-800">
          <h2 className="text-2xl font-bold mb-6 text-center text-white">Still need help?</h2>
          <div className="flex justify-center">
            <div className="bg-gray-900 rounded-lg p-6 text-center border border-gray-800 max-w-md">
              <h3 className="text-lg font-semibold mb-2 text-white">Email Support</h3>
              <p className="text-gray-300 mb-4">Get in touch with our support team</p>
              <a 
                href="mailto:davidd@elef89.com" 
                className="inline-block px-4 py-2 bg-teal-800 text-white rounded-md hover:bg-teal-700 transition-colors font-medium"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPageView; 